import { CheckBoxWithLabelWidget } from '@tableau/widgets';
import React = require('react');

import { Messages } from '~src/codegen/Localize';
import { SiteRolePickerMenu } from '~src/userManagement/components/siteRolePicker/SiteRolePickerMenu';
import { SiteRoleOption, SiteRoleOptionsResource } from '~src/userManagement/services/resources/SiteRoleOptions';
import { SiteRoles } from '~src/userManagement/users/serverApi/types/ISiteRole';

import { GrantLicenseModes } from '../../serverApi/requests/SyncActiveDirectoryGroupRequest';
import { editGroupDialogFieldStyles, editGroupDialogLabelStyles, outerCheckboxStyles, siteRolePickerMenuStyles } from '../styles/EditGroupDialogStyles';
import { EditGroupDialogLabel } from './EditGroupDialogLabel';

export interface EditGrantLicenseModeFieldProps {
  readonly siteRole: string;
  readonly grantLicenseMode: string;
  readonly setSiteRole: (siteRole: string) => void;
  readonly setGrantLicenseMode: (granteLicenseMode: GrantLicenseModes) => void;
}

export function EditGrantLicenseModeField(props: EditGrantLicenseModeFieldProps): JSX.Element  {
    const handleCheckboxChange = (checked: boolean) => {
        const grantLicenseMode = checked ? GrantLicenseModes.ON_LOGIN : undefined;
        props.setGrantLicenseMode(grantLicenseMode);
    };

    const onSiteRoleOptionSelected = (siteRoleOption: SiteRoleOption) => {
        props.setSiteRole(siteRoleOption.role);
    };

    const getSiteRoleOptionBySiteRoleCallback = (siteRole: string): SiteRoleOption => {
        return SiteRoleOptionsResource.instance.getSiteRoleOptionBySiteRole(siteRole);
    };

    return (
    <div style={editGroupDialogFieldStyles}>
        <EditGroupDialogLabel message={Messages.groupLicensedUsers()} style={editGroupDialogLabelStyles} />
        <div>
            <CheckBoxWithLabelWidget
                checked={props.grantLicenseMode === GrantLicenseModes.ON_LOGIN}
                handleChange={handleCheckboxChange}
                testId={'edit-grant-license-mode-field'}
                label={Messages.grantLicenseUponLoginCheckboxLabel()}
                style={outerCheckboxStyles}/>
            <div style={siteRolePickerMenuStyles}>
                <SiteRolePickerMenu
                disabledRoleOptions={[SiteRoleOptionsResource.instance.getSiteRoleOptionBySiteRole(SiteRoles.Unlicensed)] }
                dropdownLabel={Messages.minimumSiteRole()}
                getSiteRoleOptionBySiteRole={getSiteRoleOptionBySiteRoleCallback}
                isDisabled={props.grantLicenseMode !== GrantLicenseModes.ON_LOGIN}
                onOptionSelected={onSiteRoleOptionSelected}
                selectedRole={SiteRoleOptionsResource.instance.getSiteRoleOptionBySiteRole(props.siteRole)}
                showSiteRoleInfoLink={true}
                siteRoleOptions={SiteRoleOptionsResource.instance.getAllSiteRoleOptionsExcept(SiteRoles.ServerAdministrator)}/>
            </div>
        </div>
    </div>
    );
}